import React from "react";
import { useUISounds } from "../hooks/useUISounds";

export function DialogControls({
  step,
  isCorrect,
  userAnsweredCorrectly,
  onAttempt,
  onNext,
  hidden,
  profile,
  submittingAttempt,
}) {
  const { playButtonClick } = useUISounds();
  if (hidden) {
    return null;
  }

  if (step === 2) {
    return (
      <div className="flex gap-4">
        <button
          className="btn btn-success text-3xl btn-circular-xl"
          onClick={() => {
            playButtonClick();
            onAttempt(isCorrect);
          }}
          disabled={
            submittingAttempt || (userAnsweredCorrectly !== null && !isCorrect)
          }
        >
          {submittingAttempt ? (
            <span className="loading loading-spinner loading-sm"></span>
          ) : (
            "👍"
          )}
        </button>
        <button
          className="btn btn-error text-3xl btn-circular-xl"
          onClick={() => {
            playButtonClick();
            onAttempt(!isCorrect);
          }}
          disabled={
            submittingAttempt || (userAnsweredCorrectly !== null && isCorrect)
          }
        >
          {submittingAttempt ? (
            <span className="loading loading-spinner loading-sm"></span>
          ) : (
            "👎"
          )}
        </button>
      </div>
    );
  }

  const buttonImage =
    step === 0 && profile?.avatar_url
      ? profile.avatar_url
      : "https://vvzldbpwpccdljyhgssa.supabase.co/storage/v1/object/public/avatar//bunny.jpeg";

  return (
    <div>
      <button
        className="btn btn-primary p-0 overflow-hidden btn-circular-xl"
        onClick={() => {
          playButtonClick();
          onNext();
        }}
        disabled={submittingAttempt}
      >
        {step === 3 ? (
          <span className="text-3xl">→</span>
        ) : (
          <img
            src={buttonImage}
            alt="tap to continue"
            className="w-[80%] h-[80%] object-cover m-auto rounded-full"
          />
        )}
      </button>
    </div>
  );
}
